import React from 'react';
import { View, Text, StyleSheet } from 'react-native';
import BlankModal from './BlankModal';
import Spinner from '../molecules/Spinner';
import { getResponsivePadding, getResponsiveFontSize } from '../../helpers/utils';

interface WalletRequestLoadingModalProps {
  isVisible: boolean;
}

const WalletRequestLoadingModal: React.FC<WalletRequestLoadingModalProps> = ({ isVisible }) => {
  return (
    <BlankModal
      isVisible={isVisible}
      onClose={() => {}}
      onConfirm={() => {}}
      title="Requesting Wallet..."
      isLoading={true}>
      <View style={styles.loadingModalContent}>
        <Spinner />
        <Text style={styles.loadingText}>Please wait while we process your wallet request...</Text>
      </View>
    </BlankModal>
  );
};

const styles = StyleSheet.create({
  loadingModalContent: {
    flex: 1,
    justifyContent: 'center',
    alignItems: 'center',
    padding: getResponsivePadding(16, 18, 20)
  },
  loadingText: {
    fontSize: getResponsiveFontSize(14, 15, 16),
    color: '#4B5563',
    marginTop: getResponsivePadding(40, 44, 48),
    textAlign: 'center',
    paddingHorizontal: getResponsivePadding(8, 12, 16)
  }
});

export default WalletRequestLoadingModal;
